import React from 'react'

export default function TipoDePago({show, tipoPago, setFormaPago}) {
  return (
    <div className={show?'wrap-tipo-pago show':'wrap-tipo-pago'}>
        <div className='box-tipo-pago'>
            <div className='sm-12 md-12 lg-12'>
                <h2>¿Cuál será su metódo de pago?</h2>
            </div>
            <div className='sm-12 md-12 lg-12 botones-pago'>
                <label className='btn' onClick={()=>setFormaPago(1)}>
                    Efectivo
                </label>
          
                <label className='btn' onClick={()=>setFormaPago(2)}>
                    Con Tarjeta
                </label>
            </div>
            <span onClick={()=>tipoPago()}>x</span>
        </div>
    </div>
  )
}
